export default "__VITE_ASSET__BQzx4gVm__"